<template>
    <div :id="id" class="modal fade text-left mail-pricing" tabindex="-1" role="dialog" aria-labelledby="mail-pricing" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <!-- <div class="modal-header">
                    <h4 class="modal-title " id="mail-pricing">Mail Pricing</h4>
                    <button @click="closeModal(`#${id}`)" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <vue-feather size="14px" type="x" />
                    </button>
                </div> -->
                <div class="modal-body">
                    <h1 class="text-center font-weight-normal text-black my-2">
                        <span style="font-family: 'Body Text Slim';font-weight: bold;color: black;font-size: 32px;">Creditfixrr</span>
                        <span style="font-family: 'Body Grotesque Bold';background-color: #28c76f12;font-size: 32px;" class="text-primary font-weight-bold rounded-1-5 p-50">Mailer</span>
                    </h1>
                    <p class="paragraph-3">Simple and affordable pricing for you</p>
                    <div class="row">
                        <div class="col-4 d-flex justify-content-left align-items-center">
                            <h1 class="heading-1 text-primary font-weight-bold">
                                Envelope Size
                            </h1>
                        </div>
                        <div class="col-4 d-flex justify-content-center align-items-center">
                            <div class="rounded-1-5 p-50 text-center d-inline-block column-2">
                                <h1 class="font-weight-bold text-black">FIRST CLASS</h1>
                                <p class="paragraph-1">Black & White Letters</p>
                            </div>
                        </div>
                        <div class="col-4 d-flex justify-content-center">
                            <div class="rounded-top-1-5 p-1 d-inline-block column-3">
                                <div class="bg-black rounded-1-5 p-50 text-center d-inline-block text-white">
                                    <h1 class="font-weight-bold text-white">FIRST CLASS</h1>
                                    <p class="paragraph-2">Color Letters</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="m-0" />
                    <div class="row">
                        <div class="col-4">
                            <h3 class="text-primary">Small Envelope #10 <span class="text-black">(4x9)</span></h3>
                        </div>
                        <div class="col-4">
                            <h3>
                                $ {{ getPrice(disputeLetterStore.mails[disputeLetterStore.defaultMailer].pricing[disputeLetterStore.firstClass][disputeLetterStore.blackAndWhite][disputeLetterStore.small]) }}
                            </h3>
                        </div>
                        <div class="col-4">
                            <h3>
                                $ {{ getPrice(disputeLetterStore.mails[disputeLetterStore.defaultMailer].pricing[disputeLetterStore.firstClass][disputeLetterStore.color][disputeLetterStore.small]) }}
                            </h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <h3 class="text-primary">Medium Envelope <span class="text-black">(6x9)</span></h3>
                        </div>
                        <div class="col-4">
                            <h3>
                                $ {{ getPrice(disputeLetterStore.mails[disputeLetterStore.defaultMailer].pricing[disputeLetterStore.firstClass][disputeLetterStore.blackAndWhite][disputeLetterStore.medium]) }}
                            </h3>
                        </div>
                        <div class="col-4">
                            <h3>
                                $ {{ getPrice(disputeLetterStore.mails[disputeLetterStore.defaultMailer].pricing[disputeLetterStore.firstClass][disputeLetterStore.color][disputeLetterStore.medium]) }}
                            </h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <h3 class="text-primary">Large Envelope <span class="text-black">(9x12)</span></h3>
                        </div>
                        <div class="col-4">
                            <h3>
                                $ {{ getPrice(disputeLetterStore.mails[disputeLetterStore.defaultMailer].pricing[disputeLetterStore.firstClass][disputeLetterStore.blackAndWhite][disputeLetterStore.large]) }}
                            </h3>
                        </div>
                        <div class="col-4">
                            <h3>
                                $ {{ getPrice(disputeLetterStore.mails[disputeLetterStore.defaultMailer].pricing[disputeLetterStore.firstClass][disputeLetterStore.color][disputeLetterStore.large]) }}
                            </h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <h3 class="text-black">Ist Page E-Certified Mail <span class="text-danger">**</span></h3>
                        </div>
                        <div class="col-4">
                            <h3>
                                $ {{ getPrice(disputeLetterStore.mails[disputeLetterStore.defaultMailer].pricing[disputeLetterStore.certifiedMail][disputeLetterStore.blackAndWhite][disputeLetterStore.eCertified]) }}
                            </h3>
                        </div>
                        <div class="col-4">
                            <h3>
                                $ {{ getPrice(disputeLetterStore.mails[disputeLetterStore.defaultMailer].pricing[disputeLetterStore.certifiedMail][disputeLetterStore.color][disputeLetterStore.eCertified]) }}
                            </h3>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <h3 class="text-black">Extra Sheet(s) <span class="text-danger">*</span></h3>
                        </div>
                        <div class="col-4">
                            <h3>
                                $ {{ disputeLetterStore.mails[disputeLetterStore.defaultMailer].pricing[disputeLetterStore.certifiedMail][disputeLetterStore.blackAndWhite][disputeLetterStore.extraSheet] }}
                            </h3>
                        </div>
                        <div class="col-4">
                            <h3 class="rounded-bottom-1-5">
                                $ {{ disputeLetterStore.mails[disputeLetterStore.defaultMailer].pricing[disputeLetterStore.certifiedMail][disputeLetterStore.color][disputeLetterStore.extraSheet] }}
                            </h3>
                        </div>
                    </div>
                    <div>
                        <p class="mb-0">* A sheet is either a one sided or a two sided document.</p>
                        <p class="mb-0">** Rate includes USPS Certified Mail includes electronic signature receipt, a medium envelope + postage.</p>
                        <!-- <p class="mb-0">*** Creditfixrr Credits are non-refundable.</p> -->
                    </div>
                    <hr class="mt-1" />
                    <h1 class="font-weight-normal text-black my-50">
                        <span style="font-family: 'Body Text Slim';font-weight: bold;color: black;font-size: 32px;">Mailing Information:</span>
                    </h1>
                    <div class="container card my-50">
                        <div class="row border-light">
                            <div class="text-center d-flex justify-content-center align-items-center col-2 border-bottom-white">
                                1
                            </div>
                            <div class="col-10 py-2">
                                Mail goes out Monday - Friday Only.
                            </div>
                        </div>
                        <div class="row border-light">
                            <div class="text-center d-flex justify-content-center align-items-center col-2 border-bottom-white">
                                2
                            </div>
                            <div class="col-10 py-2">
                                If you mailed your letters before 12 PM EST, it goes out the same day.
                            </div>
                        </div>
                        <div class="row border-light">
                            <div class="text-center d-flex justify-content-center align-items-center col-2 border-bottom-white">
                                3
                            </div>
                            <div class="col-10 py-2">
                                If you mailed your letters after 12 PM EST, it goes out the next business day.
                            </div>
                        </div>
                        <div class="row border-light">
                            <div class="text-center d-flex justify-content-center align-items-center col-2 border-bottom-white">
                                4
                            </div>
                            <div class="col-10 py-2">
                                The mail status fields takes 24-48 hours to update.
                            </div>
                        </div>
                        <div class="row border-light">
                            <div class="text-center d-flex justify-content-center align-items-center col-2 border-bottom-white">
                                5
                            </div>
                            <div class="col-10 py-2">
                                All mail will arrive within 4-7 business days (That is standard for USPS first class)
                            </div>
                        </div>
                        <div class="row border-light">
                            <div class="text-center d-flex justify-content-center align-items-center col-2 border-bottom-white">
                                6
                            </div>
                            <div class="col-10 py-2">
                                To see the status of your mail, you can go to the “Mail Center” tab under the “Creditfixrr Tools” tab. and if you are a “CreditFixrr Business” user you can find your clients mail letters inside of their Client file under their “Mail Center” tab.
                            </div>
                        </div>
                    </div>
                    <hr class="mt-1" />
                    <h1 class="font-weight-normal text-black my-50">
                        <span style="font-family: 'Body Text Slim';font-weight: bold;color: black;font-size: 32px;">Mailing Statuses</span>
                    </h1>
                    <div class="row match-height mail-status">
                        <div class="col-sm-12 col-md-4">
                            <div class="card shadow-none bg-transparent border-secondary">
                                <div class="card-body">
                                    <h4 class="card-title">CREATED</h4>
                                    <p class="card-text">Your dispute letter has been generated and ready to be submitted to the mail center.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="card shadow-none bg-transparent border-secondary">
                                <div class="card-body">
                                    <h4 class="card-title">SUBMITTED</h4>
                                    <p class="card-text">Your dispute letter has been submitted and approved by the mail center for processing.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="card shadow-none bg-transparent border-secondary">
                                <div class="card-body">
                                    <h4 class="card-title">PROCESSING PREPARATION</h4>
                                    <p class="card-text">Your Dispute letter is being processed to be sent to production.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="card shadow-none bg-transparent border-secondary">
                                <div class="card-body">
                                    <h4 class="card-title">SENT TO PRODUCTION</h4>
                                    <p class="card-text">Your dispute letter has been processed and sent to production.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="card shadow-none bg-transparent border-secondary">
                                <div class="card-body">
                                    <h4 class="card-title">PREPARED FOR PRODUCTION</h4>
                                    <p class="card-text">Your dispute letter has been prepared for production and is ready to printed.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="card shadow-none bg-transparent border-secondary">
                                <div class="card-body">
                                    <h4 class="card-title">PRINTED</h4>
                                    <p class="card-text">Your dispute letter has been printed and is ready to be enveloped.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="card shadow-none bg-transparent border-secondary">
                                <div class="card-body">
                                    <h4 class="card-title">ENVELOPED</h4>
                                    <p class="card-text">Your dispute letter has been enveloped and ready to be passed to the postal service for delivery.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="card shadow-none bg-transparent border-secondary">
                                <div class="card-body">
                                    <h4 class="card-title">PASSED TO POSTAL SERVICE</h4>
                                    <p class="card-text">The postal service has received your dispute letter(s) and has taken over delivery operations.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useDisputeLetterStore } from '../../stores/DisputeLetterStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { centToDollar, closeModal } from '../../utilities/_helpers'
    import { fix, add, round, string } from 'mathjs'
    export default {
        components: {
        },
        props:{
            id: String,
        },
        setup(props) {
            return {
                centToDollar: centToDollar,
                closeModal: closeModal,
                disputeLetterStore: useDisputeLetterStore(),
                reportStore: useReportStore()
            }
        },
        methods: {
            getPrice(price) {
                const serviceCharges = centToDollar(process.env.MIX_SWITCHMAIL_SERVICE_CHARGES);
                return (fix(add(price, serviceCharges), 2)).toFixed(2);
            }
        },
        computed: {
           
        }
    }
</script>
<style>
    .rounded-1-5 {
        border-radius: 1.5rem;
    }
    .rounded-top-1-5 {
        border-top-left-radius: 1.5rem;
        border-top-right-radius: 1.5rem;
    }
    .rounded-bottom-1-5 {
        border-bottom-right-radius: 1.5rem;
        border-bottom-left-radius: 1.5rem;
    }
    .mail-pricing .modal-body .row .col-4 h1 {
        color: #000;
        font-family: 'Body Grotesque Bold';
    }
    .mail-pricing .modal-body .row .col-4:nth-child(1) h3 {
        font-family: 'BodyGrotesque Bold';
        font-weight: bold;
    }
    .mail-pricing .modal-body .row .col-4:nth-child(1) h3,
    .mail-pricing .modal-body .row .col-4:nth-child(2) h3
    {
        margin-bottom: 0;
        padding: 10px 0px;
        color: #000;
        font-size: 16px;
    }
    .mail-pricing .modal-body .row .col-4:nth-child(2) h3
    {
        text-align: center;
    }
    .mail-pricing .modal-body .row .column-2 {
        background-color: #28c76f4f;
    }
    .mail-pricing .modal-body .row .column-3 {
        background-color: rgba(40, 199, 111, 0.31);
        width: 70%;
        text-align: center;
    }
    .mail-pricing .modal-body .row .col-4:nth-child(3) h3 {
        margin: auto;
        margin-bottom: 0;
        font-size: 16px;
        padding: 10px;
        text-align: center;
        width: 70%;
        color: #000;
        background-color: rgba(40, 199, 111, 0.31);
    }
    .mail-pricing .heading-1 {
        font-size: 32px;
        margin: 0;
    }
    .mail-pricing h4 {
        font-family: 'Body Grotesque Bold';
    }
    .mail-pricing .paragraph-1 {
        font-family: 'Body Text Slim';
        font-size: 22px;
        font-weight: bold;
        color: #000;
        margin-top: 0rem;
        margin-bottom: 0rem;
        letter-spacing: 2px;
    }
    .mail-pricing .paragraph-2 {
        font-family: 'Body Text Slim';
        font-size: 22px;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
        margin-top: 0;
        margin-bottom: 0;
    }
    .mail-pricing .paragraph-3 {
        font-family: 'Body Grotesque Bold';
        font-size: 20px;
        font-weight: bold;
        color: #000;
        text-align: center;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
    .mail-pricing .mail-status h4 {
        text-align: center;
        margin-bottom: 0;
    }
    .mail-pricing .mail-status p {
        text-align: center;
    }
    .mail-pricing hr {
        border-top: 4px solid #4b9a5e;
    }
    @media screen and (max-width: 991px) {
        .mail-pricing .modal-body .row .column-2 {
            background-color: transparent;
        }
        .mail-pricing .modal-body .row .column-2 h1, .mail-pricing .modal-body .row .column-2 p {
            font-size: 20px;
        }
        .mail-pricing .modal-body .row .column-3 h1, .mail-pricing .modal-body .row .column-3 p {
            font-size: 20px;
        }
        .mail-pricing .modal-body .row .column-3 {
            background-color: transparent;
        }
        .mail-pricing .heading-1 {
            font-size: 24px;
        }
        .mail-pricing .modal-body .row .col-4:nth-child(3) h3 {
            background-color: transparent;
        }
    }
</style>